
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, PropSync, Watch } from "vue-property-decorator";
@Component({
	name: "CenterPagination"
})
export default class CenterPagination extends Vue {
	@PropSync("currentPage", { type: Number }) currentPageC!: number;
	@PropSync("total", { type: Number }) totalC!: number;
	@PropSync("pages", { type: Number }) pagesC!: number;
	@PropSync("currentPageSize", { type: Number }) currentPageSizeC!: number;
	// @Prop({
	//   type: Number,
	//   default: 0,
	//   validator: (value) => {
	//     return value;
	//   },
	// }) total!:number;
	mounted() {
		document.getElementsByClassName(
			"el-pagination__jump"
		)[0].childNodes[0].nodeValue = "跳至";
	}
	updated() {}
	private currentChange(val: number) {
		this.$emit("currentChange", val);
	}
	@Watch("currentPageC")
	onPageChanged(newValue: number, oldValue: number) {}
	@Watch("pagesC")
	onTotalChanged(newValue: number, oldValue: number) {
		if (
			document
				.getElementsByClassName("el-pagination__jump")[0]
				.getElementsByClassName("el-pagination__total")[0]
		) {
			document
				.getElementsByClassName("el-pagination__jump")[0]
				.getElementsByClassName("el-pagination__total")[0].innerHTML =
				"/" + (newValue || 0);
		}
	}
}
